import React, { useEffect, useState, useCallback } from "react";
import { Modal, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { ChevronDown } from "react-feather";
import DataTable from "react-data-table-component";
import moment from "moment";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Flatpickr from "react-flatpickr";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import ClearSharpIcon from "@mui/icons-material/ClearSharp";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import DoneIcon from "@mui/icons-material/Done";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import CircularProgress from "@mui/material/CircularProgress"; // Added for row-level loading
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";

const RecentApplicants = ({ userType }) => {
  const sessionId = localStorage.getItem("sessionId");
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [instituteId, setInstituteId] = useState("");
  const [instituteAppData, setInstituteAppData] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // Changed from 0 to 1 for consistency with pagination
  const [candidateList, setCandidateList] = useState([]);
  const [totalRows, setTotalRows] = useState(0); // Changed default to 0 as it’s more logical
  const [jobAppInfoData, setJobAppInfoData] = useState("");
  console.log("jobAppInfoData", jobAppInfoData);

  // ...............................................Modal States...........................................
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleShowModal = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);

  const [showAppliedModalSchedule, setShowAppliedModalSchedule] = useState(false); // Fixed typo
  const handleCloseModalSchedule = () => setShowAppliedModalSchedule(false);

  const [showInstModal, setShowInstModal] = useState(false);
  const handleInstModal = () => setShowInstModal(true);
  const handleCloseInstModal = () => setShowInstModal(false);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const handleCancel = () => setShowCancelModal(true);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  const [showRejectModal, setShowRejectModal] = useState(false);
  const handleReject = () => setShowRejectModal(true);
  const handleCloseRejectModal = () => setShowRejectModal(false);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const handleHistoryShow = () => setShowHistoryModal(true);
  const handleCloseHistoryModal = () => setShowHistoryModal(false);

  const [showInfoModal, setShowInfoModal] = useState(false);
  const handleInfoShow = () => setShowInfoModal(true);
  const handleCloseInfoModal = () => setShowInfoModal(false);

  const [unauthModal, setUnauthModal] = useState(false);
  const handleUnauthModal = () => setUnauthModal(true);
  const handleCloseUnauthModal = () => setUnauthModal(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const handleCancelConfirm = () => setShowConfirmationModal(false);

  // ...............................................State Variables...........................................
  const [jobAppId, setJobAppId] = useState(0); // Fixed typo in variable name
  const [candidateId, setCandidateId] = useState(null);
  const [scheduleTime, setScheduleTime] = useState("");
  const [placeType, setPlaceType] = useState(null);
  const [placeDetails, setPlaceDetails] = useState("");
  const [remark, setRemark] = useState("");
  const [unAuthorizeError, setUnAuthorizeError] = useState("");
  const [jobHistory, setJobHistory] = useState("");
  const [jobInfo, setJobInfo] = useState("");
  const [hiringStatuses, setHiringStatuses] = useState({});
  const [hiringStatusValue, setHiringStatusValue] = useState({}); // Fixed naming convention
  const [candData, setCandData] = useState("");
  const [search, setSearch] = useState("");
  const [insCandidateList, setInsCandidateList] = useState([]);
  const [groupClassName, setGroupClassName] = useState([]);
  const [applicationStatus, setApplicationStatus] = useState("");
  const [formChanged, setFormChanged] = useState(false);
  const [loadingRows, setLoadingRows] = useState({}); // New state for row-level loading
console.log("insCandidateList",insCandidateList);

  // ...............................................GetAll ...........................................
  const JobAppGetAll = useCallback(async (page) => {
    setCurrentPage(page);
    try {
      setIsLoading(true);
      const requestBody = { sessionId, pageNumber: page, pageSize: 10 };
      const response = await axios.post(`/JobApplication/GetAll?ts=${Date.now()}`, requestBody, {
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache", Expires: "0" },
      });
      const res = response?.data?.responseData || {};
      console.log("hiring status", res);
      setCandidateList(res?.jobApplications || []);
      setTotalRows(res?.paging?.totalrecords || 0);
      setIsError(!(res?.jobApplications?.length > 0));
    } catch (err) {
      console.error("Error fetching jobs:", err);
      setIsError(true);
      if (err.response?.status === 409) {
        setUnAuthorizeError(err.response.data.message);
        handleUnauthModal();
      }
    } finally {
      setIsLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    JobAppGetAll(1);
  }, [JobAppGetAll]);

  // ...............................................Hold Application...........................................
  const HoldApplication = async (id) => {
    if (loadingRows[id]) return; // Prevent multiple clicks
    try {
      setLoadingRows((prev) => ({ ...prev, [id]: true }));
      // Optimistic UI update
      setCandidateList((prev) =>
        prev.map((item) =>
          item.jbApplctnId === id ? { ...item, hiringStatus: 11, hiringStatusName: "Hold" } : item
        )
      );
      const requestBody = { sessionId, jbApplctnId: id };
      const response = await axios.post("/JobApplication/HoldJobApplication", requestBody);
      setJobAppInfoData(response.data);
      toast.success(response.data.message);
      // No full refresh on success, relying on optimistic update
    } catch (error) {
      console.error("API Error:", error);
      // Rollback on error
      setCandidateList((prev) =>
        prev.map((item) =>
          item.jbApplctnId === id ? { ...item, hiringStatus: 4, hiringStatusName: "Shortlisted" } : item
        )
      );
      toast.error(error?.response?.data?.message || "Something went wrong");
      await JobAppGetAll(currentPage); // Full refresh only on error
    } finally {
      setLoadingRows((prev) => ({ ...prev, [id]: false }));
    }
  };

  // ...............................................UnHold Application...........................................
  const UnHoldApplication = async (id) => {
    if (loadingRows[id]) return; // Prevent multiple clicks
    try {
      setLoadingRows((prev) => ({ ...prev, [id]: true }));
      // Optimistic UI update
      setCandidateList((prev) =>
        prev.map((item) =>
          item.jbApplctnId === id ? { ...item, hiringStatus: 4, hiringStatusName: "Shortlisted" } : item
        )
      );
      const requestBody = { sessionId, jbApplctnId: id };
      const response = await axios.post("/JobApplication/UnHoldJobApplication", requestBody, {
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache", Expires: "0" },
      });
      if (response.data?.status === "Warning") {
        toast.warning(response.data.message);
      } else if (response.data) {
        toast.success(response.data.message);
      } else {
        throw new Error("Unexpected response from server");
      }
      setJobAppInfoData(response.data);
      // No full refresh on success, relying on optimistic update
    } catch (error) {
      console.error("API Error:", error);
      // Rollback on error
      setCandidateList((prev) =>
        prev.map((item) =>
          item.jbApplctnId === id ? { ...item, hiringStatus: 11, hiringStatusName: "hold" } : item
        )
      );
      toast.error(error?.response?.data?.message || "Something went wrong");
      await JobAppGetAll(currentPage); // Full refresh only on error
    } finally {
      setLoadingRows((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Debounce to prevent rapid clicks
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };
  const handleHold = debounce(HoldApplication, 500);
  const handleUnhold = debounce(UnHoldApplication, 500);

  // ...............................................Reject Application...........................................
  const RejectApplication = async () => {
    try {
      const requestBody = { sessionId, jbApplctnId: jobAppId, hiringStatus: "Rejected", remark: "" };
      const response = await axios.post("/JobApplication/UpdateHiringStatus", requestBody);
      if (response.data?.status === "Warning") {
        toast.warning(response.data.message);
      } else if (response.data) {
        toast.success(response.data.message);
      } else {
        toast.error("Unexpected response from server");
      }
      setJobAppInfoData(response.data);
      await JobAppGetAll(currentPage);
      handleCloseCancelModal();
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "Network error, please try again");
    }
  };

  // ...................................................Accept Application..........................................
  const AcceptApplication = async (id) => {
    try {
      const requestBody = { sessionId, jbApplctnId: id, hiringStatus: "Shortlisted", remark: "" };
      const response = await axios.post("/JobApplication/UpdateHiringStatus", requestBody);
      if (response.data?.status === "Warning") {
        toast.warning(response.data.message);
      } else if (response.data) {
        toast.success(response.data.message);
      } else {
        toast.error("Unexpected response from server");
      }
      await JobAppGetAll(currentPage);
      getGetAllCandidate();
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "Network error, please try again");
    }
  };

  // ...................................................Accept Application As Institute..........................................
  const AcceptApplicationAsInst = async (cnddtId) => {
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: instituteAppData.jbApplctnId,
        hiringStatus: "Shortlisted",
        remark: "",
        insttUid: instituteAppData.userUid,
        cnddtID: cnddtId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      const response = await axios.post("/JobApplication/UpdateHiringStatusForInstituteCandidates", requestBody);
      toast.success(response.data.message);
      await JobAppGetAll(currentPage);
      getGetAllCandidate();
      InstituteCandidateHiringStatus(candData);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "Failed to shortlist");
    }
  };

  // ...............................................Reject Application As Institute...........................................
  const RejectApplicationAsInst = async () => {
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: instituteAppData.jbApplctnId,
        hiringStatus: "Rejected",
        remark: "",
        insttUid: instituteAppData.userUid,
        cnddtID: candidateId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      const response = await axios.post("/JobApplication/UpdateHiringStatusForInstituteCandidates", requestBody);
      setJobAppInfoData(response.data);
      handleCloseRejectModal();
      getGetAllCandidate();
      InstituteCandidateHiringStatus(candData);
      toast.success(response.data.message);
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to reject application");
    }
  };

  // ...................................................Schedule Interview..........................................
  const ScheduleInterview = async () => {
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: jobAppId,
        scheduleTime,
        placeType: parseInt(placeType, 10),
        placeDetails,
        remark,
      };
      const response = await axios.post("/JobApplication/ScheduleInterview", requestBody);
      toast.success(response.data.message);
      await JobAppGetAll(currentPage);
      handleCloseModal();
      setScheduleTime("");
      setPlaceType(null);
      setPlaceDetails("");
      setRemark("");
      setFormChanged(false);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "Failed to schedule interview");
    }
  };

  // ...................................................Schedule Interview As Institute..........................................
  const ScheduleInterviewAsInst = async () => {
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: instituteAppData.jbApplctnId,
        scheduleTime,
        placeType: parseInt(placeType, 10),
        placeDetails,
        remark,
        insttUid: instituteAppData.userUid,
        cnddtID: candidateId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      const response = await axios.post("/JobApplication/ScheduleInterviewForInstituteCandidates", requestBody);
      toast.success(response.data.message);
      await JobAppGetAll(currentPage);
      handleCloseModalSchedule();
      setScheduleTime("");
      setPlaceType(null);
      setPlaceDetails("");
      setRemark("");
      setFormChanged(false);
      InstituteCandidateHiringStatus(candData);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.message || "Some problem occurred!");
    }
  };

  // ........................................Job History Start..........................
  const JobHistory = async (id, candidateId) => {
    const data = { sessionId, jbApplctnId: id, cnddtID: candidateId || null };
    console.log("data22", data);
    try {
      const response = await axios.post("/JobApplication/GetHistory", data);
      console.log("HISTORY", response.data.responseData);
      setJobHistory(response.data.responseData);
    } catch (e) {
      console.log("Unapply ", e);
    }
  };

  // ........................................Job Info Start..........................
  const JobInfoData = (jobId) => {
    axios
      .get(`/Job/GetJobDetails?JobId=${jobId}`)
      .then((response) => {
        const res = response.data.responseData;
        setJobInfo(res);
        console.log("edit data", res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.log(error);
        } else {
          console.log(error);
        }
      });
  };

  // ...............................................Institute Candidate Hiring Status ...........................................
  const getGetAllCandidate = async (page = 1) => {
    const data = { pageNumber: page, pageSize: 10 };
    try {
      const response = await axios.post(
        `/Candidate/GetAllByInstt/${instituteId}?Type=${instituteAppData.grpTypName}&TypeId=${instituteAppData.grpTypeId}&Search=${search}`,
        data
      );
      const res = response.data.responseData.items;
      console.log("Candidate response:", data);
      setInsCandidateList(res);
      if (res.length > 0 && res[0].insttCandidateProfile?.insttClssName) {
        setGroupClassName(res[0].insttCandidateProfile.insttClssName);
      } 
      
      setIsLoading(false);
      if (res.length > 0) {
        await Promise.all(res.map((candidate) => InstituteCandidateHiringStatus(candidate)));
      }
    } catch (e) {
      console.error("Error fetching candidates:", e);
    }
  };

  const InstituteCandidateHiringStatus = async (candidate) => {
    if (!candidate || !candidate.cnddtId) {
      console.log("candidate", candidate);
      return;
    }
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: instituteAppData?.jbApplctnId,
        insttUid: instituteAppData?.userUid,
        cnddtID: candidate?.cnddtId,
        grpTypName: instituteAppData?.grpTypName,
        grpTypeId: instituteAppData?.grpTypeId,
      };
      const response = await axios.post("/JobApplication/GetInstituteCandidateHiringStatus", requestBody);
      console.log("response status", response.data.responseData);
      const hiringStatusName = response.data.responseData.hiringStatusName || "Applied";
      const hiringStatusValue = response.data.responseData.hiringStatus || 0;
      setHiringStatuses((prev) => ({ ...prev, [candidate.cnddtId]: hiringStatusName }));
      setHiringStatusValue((prev) => ({ ...prev, [candidate.cnddtId]: hiringStatusValue }));
    } catch (error) {
      console.error("Error fetching hiring statuses:", error);
    }
  };

  // ...............................................Accept Interview Application As Institute...........................................
  const AcceptInterviewApplicationAsInst = async (id, hiringStatus) => {
    try {
      const requestBody = {
        sessionId,
        jbApplctnId: id,
        hiringStatus,
        remark: "",
        insttUid: instituteAppData.userUid,
        cnddtID: candidateId,
        grpTypName: instituteAppData.grpTypName,
        grpTypeId: instituteAppData.grpTypeId,
      };
      console.log("AcceptApplication", requestBody);
      const response = await axios.post("/JobApplication/UpdateHiringStatusForInstituteCandidates", requestBody);
      console.log("getAcceptApplication", response);
      toast.success(response.data.message);
      setInstituteAppData((prevData) => ({ ...prevData, hiringStatus }));
      await JobAppGetAll(currentPage);
      InstituteCandidateHiringStatus(instituteAppData);
      getGetAllCandidate();
      handleCancelConfirm();
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to update status");
    }
  };

  // ...............................................Utility Functions...........................................
  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });
    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
  };

  const handleFieldChange = (setter, value, fieldName) => {
    setter(value);
    const updatedScheduleTime = fieldName === "scheduleTime" ? value : scheduleTime;
    const updatedPlaceType = fieldName === "placeType" ? value : placeType;
    const updatedPlaceDetails = fieldName === "placeDetails" ? value : placeDetails;
    const allFieldsFilled = updatedScheduleTime && updatedPlaceType && updatedPlaceType !== "0" && updatedPlaceDetails.trim() !== "";
    setFormChanged(allFieldsFilled);
  };

  useEffect(() => {
    if (instituteId || search) getGetAllCandidate();
  }, [instituteId, search]);

  useEffect(() => {
    if (candData && Array.isArray(candData)) {
      candData.forEach((candidate) => InstituteCandidateHiringStatus(candidate));
    }
  }, [candData]);

  // ...............................................Table Columns...........................................
  const columns = [
    {
      name: "CANDIDATES",
      sortable: true,
      center: true,
      cell: (row) => (
        <div className="mt-2 mb-2 candidate-main-section" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
          <Link to={`/Candidate/${row.userUid}`}>  <img src={row.userProfilePic} alt="User" style={{ width: "50px", height: "50px", borderRadius: "50%" }} /></Link>
          <Link to={`/Candidate/${row.userUid}`}> <div className="pointer">{row.userName}</div></Link>
          <div className="job-footer-left">
            <ul className="job-tag mb-0" style={{ margin: 0, padding: 0 }}>
              {row.jbApplctnTypeName === "Candidate" ? (
                <Link to={`/Candidate/${row.userUid}`}><li className="mb-0">{row.jbApplctnTypeName}</li></Link>
              ) : (
                <Link to={`/Institution/${row.userUid}`}><li className="mb-0">{row.jbApplctnTypeName}</li></Link>
              )}
            </ul>
          </div>
          <div className="pointer tdm-Candid">{moment.utc(row.appliedTime).local().format("DD MMM YYYY - HH:mm A")}</div>
        </div>
      ),
    },
    {
      name: "JOB NAME",
      center: true,
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center" }}>
          <div className="pointer jobinfo f-600 text-center" onClick={() => { handleInfoShow(); JobInfoData(row.jobId); }}>
            {row.jobTitle}
          </div>
        </div>
      ),
    },
    {
      name: "STATUS",
      center: true,
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {row.jbApplctnType === 2 ? (
            row.hiringStatus === 9 ? (
              <div className="job-footer-left"><ul style={{ margin: 0, padding: 0 }}><li>{row.hiringStatusName}</li></ul></div>
            ) : (
              <div className="job-footer-left"><ul className="green" style={{ margin: 0, padding: 0 }}><li>{row.hiringStatusName}</li></ul></div>
            )
          ) : (
            <div className="job-footer-left">
              <ul
                className={
                  row.hiringStatus === 0
                    ? "red"
                    : row.hiringStatus === 1
                    ? ""
                    : row.hiringStatus === 5
                    ? "orange"
                    : row.hiringStatus === 7 || row.hiringStatus === 8
                    ? "red"
                    : "green"
                }
                style={{ margin: 0, padding: 0 }}
              >
                <li>{row.hiringStatusName}</li>
              </ul>
            </div>
          )}
          <span className="ms-2">
            <Tooltip title="History" arrow>
              <HistorySharpIcon onClick={() => { handleHistoryShow(); JobHistory(row.jbApplctnId); }} className="pointer mt-0" />
            </Tooltip>
          </span>
        </div>
      ),
    },
    {
      name: "ACTION",
      center: true,
      cell: (row) => {
        const isDisabled = loadingRows[row.jbApplctnId] || row.hiringStatus === 11;
        console.log("status", row.hiringStatus);
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            {row.jbApplctnType === 2 ? (
              <Tooltip title="Candidate List" arrow>
                <PeopleSharpIcon
                  className="pointer blueIcon"
                  onClick={() => {
                    setJobAppId(row.jbApplctnId);
                    setInstituteId(row.userUid);
                    setInstituteAppData(row);
                    setTimeout(() => handleInstModal(), 100);
                  }}
                />
              </Tooltip>
            ) : (
              <>
                {row.hiringStatus === 6 || row.hiringStatus === 7 || row.hiringStatus === 8 ? (
                  ""
                ) : row.hiringStatus === 5 ? (
                  <Link to={`/Interviews`}><span className="text-warning f-14 f-700 pointer">Go to Interview</span></Link>
                ) : (
                  <>
                    {(row.hiringStatus === 4 || row.hiringStatus === 11) && (
                      <>
                        <Tooltip title="Schedule" arrow>
                          <CalendarMonthSharpIcon
                            className={`pointer calendarIcon ${isDisabled ? "disabled-icon" : ""}`}
                            onClick={!isDisabled ? () => { handleShowModal(); setJobAppId(row.jbApplctnId); } : undefined}
                          />
                        </Tooltip>
                        {loadingRows[row.jbApplctnId] ? (
                          <CircularProgress size={20} />
                        ) : row.hiringStatus === 11 ? (
                          <Tooltip title="UnHold" arrow>
                            <PauseCircleFilledIcon
                              className="pointer blueIcon"
                              onClick={() => handleUnhold(row.jbApplctnId)}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Hold" arrow>
                            <PauseCircleOutlineIcon
                              className="pointer blueIcon"
                              onClick={() => handleHold(row.jbApplctnId)}
                            />
                          </Tooltip>
                        )}
                      </>
                    )}
                    {row.hiringStatus !== 4 && row.hiringStatus !== 11 && row.hiringStatusName !== "Withdraw" && (
                      <Tooltip title="Shortlist" arrow>
                        <CheckSharpIcon
                          className={`pointer checkIcon ${isDisabled ? "disabled-icon" : ""}`}
                          onClick={!isDisabled ? () => AcceptApplication(row.jbApplctnId) : undefined}
                        />
                      </Tooltip>
                    )}
                    {row.hiringStatusName !== "Withdraw" && (
                      <Tooltip title="Reject" arrow>
                        <ClearSharpIcon
                          className={`pointer rejectIcon ${isDisabled ? "disabled-icon" : ""}`}
                          onClick={!isDisabled ? () => { handleCancel(); setJobAppId(row.jbApplctnId); } : undefined}
                        />
                      </Tooltip>
                    )}
                    <Tooltip title="View resume" arrow>
                      <Link target="_blank" to={`/Resume/Candidate?userUID=${row.userUid}`}>
                        <VisibilitySharpIcon className="blueIcon" />
                      </Link>
                    </Tooltip>
                  </>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];

  const insColumns = [
    {
      name: "CANDIDATES",
      sortable: true,
      cell: (row) => (
        <div className="pt-2 pb-2 inst-cacndidate-section" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }} className="inst-cacndidate-list-style">
            <img src={row.profileImage} alt="User" style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
            <div className="row">
              <div>{row.firstName}</div>
              <div>{row.lastName}</div>
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "BATCH NAME",
      center: true,
      sortable: true,
      selector: (row) =>
        Array.isArray(row.insttCandidateProfile.batchNames)
          ? row.insttCandidateProfile.batchNames.join(", ")
          : row.insttCandidateProfile.batchNames,
    },
    {
      name: "STATUS",
      center: true,
      sortable: true,
      cell: (row) => {
        const statusValue = hiringStatusValue[row.cnddtId];
        const statusText = hiringStatuses[row.cnddtId] || "Applied";
        let badgeClass = "green";
        if (statusValue === 1) badgeClass = "default";
        else if (statusValue === 5) badgeClass = "orange";
        else if (statusValue === 7 || statusValue === 8) badgeClass = "red";
        return (
          <div className="react-table-inner-section">
            <div className={`job-footer-left ${badgeClass}`}>
              <ul style={{ margin: 0, padding: 0 }}><li>{statusText}</li></ul>
            </div>
            <span className="ms-2">
              {/* <Tooltip title="History" arrow>
                <HistorySharpIcon
                  onClick={() => { handleHistoryShow(); JobHistory(instituteAppData?.jbApplctnId, row.cnddtId); setCandidateId(row.cnddtId); }}
                  className="pointer mt-0"
                />
              </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      name: "ACTION",
      center: true,
      cell: (row) => {
        const statusValue = hiringStatusValue[row.cnddtId];
        const isDisabled = statusValue === 11;
        return (
          <div>
            {statusValue === 7 || statusValue === 6 || statusValue === 8 ? (
              ""
            ) : statusValue === 5 ? (
              <Link to={`/Interviews`}><span className="text-warning f-14 f-700 pointer">Go to Interview</span></Link>
            ) : (
              <>
                {statusValue === 4 ? (
                  <span className="me-2">
                    <Tooltip title="Schedule" arrow>
                      <CalendarMonthSharpIcon
                        className={`pointer ${isDisabled ? "disabled-icon" : ""}`}
                        onClick={!isDisabled ? () => { setShowAppliedModalSchedule(true); setCandidateId(row.cnddtId); setCandData(row); } : undefined}
                      />
                    </Tooltip>
                  </span>
                ) : (
                  <span className="me-2">
                    <Tooltip title="Shortlist" arrow>
                      <DoneIcon
                        className={`pointer checkIcon ${isDisabled ? "disabled-icon" : ""}`}
                        onClick={!isDisabled ? () => { AcceptApplicationAsInst(row.cnddtId); InstituteCandidateHiringStatus(row); } : undefined}
                      />
                    </Tooltip>
                  </span>
                )}
                <span className="me-2">
                  <Tooltip title="Reject" arrow>
                    <ClearSharpIcon
                      className={`pointer rejectIcon ${isDisabled ? "disabled-icon" : ""}`}
                      onClick={!isDisabled ? () => { setShowConfirmationModal(true); setApplicationStatus("Rejected"); setJobAppId(row.jbApplctnId); setCandidateId(row.cnddtId); } : undefined}
                    />
                  </Tooltip>
                </span>
                <Link target="_blank" to={`/Resume?userUID=${row.cnddtUID}&InstnCnddtId=${row.insttCandidateProfile.instnCnddtId}`}>
                  <Tooltip title="View" arrow>
                    <VisibilitySharpIcon style={{ cursor: "pointer", color: "black" }} className="ms-2 joblist-eye-icon Dark-icon-color" />
                  </Tooltip>
                </Link>
              </>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <section className="pricing-section-three container jobapplication application-drop-section">
        <div className="row">
          <div className="delete-title mb-1 col-md-6">
            <h1 className="orange-title">
              <span className="orange-box me-2"></span>Manage Applications
            </h1>
          </div>
          <div className="mb-1 col-6 text-start"></div>
        </div>
        <div className="container st3">
          <div className="row">
            <div className="col-lg-12">
              {isLoading ? (
                <div className="row mt-2">
                  {Array(4).fill().map((_, i) => (
                    <div key={i} className="col-md-12 mt-2">
                      <ShimmerDiv mode="light" height={100} width={"100%"} />
                    </div>
                  ))}
                </div>
              ) : isError || candidateList.length === 0 ? (
                <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                  <img src={error} alt="404 Not Found" width={300} />
                </div>
              ) : (
                <div className="table-res d-flex">
                  <div className="react-dataTable react-table-colorclass react-table-section">
                    <DataTable
                      noHeader
                      pagination
                      columns={columns}
                      data={candidateList}
                      progressPending={isLoading}
                      paginationServer
                      paginationPerPage={10}
                      paginationTotalRows={totalRows}
                      paginationRowsPerPageOptions={[]}
                      paginationDefaultPage={currentPage}
                      onChangePage={(page) => JobAppGetAll(page)}
                      sortIcon={<ChevronDown size={10} />}
                      className="react-dataTable"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Institute Modal */}
      <Modal show={showInstModal} onHide={handleCloseInstModal} centered size="xl">
        <Modal.Header>
          <Modal.Title>Institute candidate details ({groupClassName})</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={() => { handleCloseInstModal(); setInstituteId(""); setInstituteAppData(""); setInsCandidateList([]); }} />
        </Modal.Header>
        <Modal.Body className="settings jobapplication">
          <div className="container st3">
            <div className="row">
              <div className="col-lg-12">
                <div className="manage-search-bar">
                  <SearchIcon className="icon" />
                  <input
                    type="text"
                    placeholder="Search Candidates"
                    className="manage-search-input Dark-Manage-Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                {isLoading ? (
                  <div className="row mt-2">
                    {Array(4).fill().map((_, i) => (
                      <div key={i} className="col-md-12 mt-2">
                        <ShimmerDiv mode="light" height={100} width={"100%"} />
                      </div>
                    ))}
                  </div>
                ) : isError ? (
                  <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                    <img src={error} alt="404 Not Found" width={300} />
                  </div>
                ) : (
                  <div className="table-res">
                    <div className="react-dataTable react-table-colorclass">
                      <DataTable
                        noHeader
                        pagination
                        columns={insColumns}
                        paginationPerPage={10}
                        className="react-dataTabley"
                        sortIcon={<ChevronDown size={10} />}
                        paginationDefaultPage={currentPage}
                        data={insCandidateList}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Schedule Modal */}
      <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title>Add Interview Schedule Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="about">Schedule Time <span style={{ color: "red" }} className="ms-2">*</span></label>
              <Flatpickr
                data-enable-time
                value={scheduleTime}
                onChange={(dates) => handleFieldChange(setScheduleTime, dates[0], "scheduleTime")}
                options={{ enableTime: true, dateFormat: "Y-m-d H:i", minDate: new Date(), static: true }}
                className="form-control Dark-Input-from-group"
                placeholder="Enter schedule time"
              />
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="schedule-time">Interview Mode Type <span style={{ color: "red" }} className="ms-2">*</span></label>
              <select
                id="place-type"
                onChange={(e) => handleFieldChange(setPlaceType, e.target.value, "placeType")}
                className="form-control Dark-Input-from-group"
              >
                <option value="0">Select</option>
                <option value="1">OnSite</option>
                <option value="2">Remote</option>
                <option value="3">Hybrid</option>
              </select>
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="about">Place Details <span style={{ color: "red" }} className="ms-2">*</span></label>
              <input
                type="text"
                value={placeDetails}
                onChange={(e) => handleFieldChange(setPlaceDetails, e.target.value, "placeDetails")}
                placeholder="Enter place details"
                className="form-control Dark-Input-from-group"
              />
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="description">
              <label htmlFor="about" className="f-600">Remark</label>
              <Form.Control
                as="textarea"
                rows={3}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter Remark"
                className="Dark-Input-from-group"
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button className={`btn btn-danger apply-job me-2 ${!formChanged ? "disabled" : ""}`} onClick={ScheduleInterview} disabled={!formChanged}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>

      {/* Schedule Institute Modal */}
      <Modal show={showAppliedModalSchedule} onHide={handleCloseModalSchedule} centered>
        <Modal.Header>
          <Modal.Title>Add Interview Schedule Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModalSchedule} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="about">Schedule Time <span style={{ color: "red" }} className="ms-2">*</span></label>
              <Flatpickr
                data-enable-time
                value={scheduleTime}
                onChange={(dates) => handleFieldChange(setScheduleTime, dates[0], "scheduleTime")}
                options={{ enableTime: true, dateFormat: "Y-m-d H:i", minDate: new Date(), static: true }}
                className="form-control Dark-Input-from-group"
                placeholder="Enter schedule time"
              />
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="schedule-time">Interview Mode Type <span style={{ color: "red" }} className="ms-2">*</span></label>
              <select
                id="place-type"
                onChange={(e) => handleFieldChange(setPlaceType, e.target.value, "placeType")}
                className="form-control Dark-Input-from-group"
              >
                <option value="0">Select Type</option>
                <option value="1">OnSite</option>
                <option value="2">Remote</option>
                <option value="3">Hybrid</option>
              </select>
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <div className="post-form-group">
              <label htmlFor="about">Place Details <span style={{ color: "red" }} className="ms-2">*</span></label>
              <input
                type="text"
                value={placeDetails}
                onChange={(e) => handleFieldChange(setPlaceDetails, e.target.value, "placeDetails")}
                placeholder="Enter place details"
                className="form-control Dark-Input-from-group"
              />
            </div>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="description">
              <label htmlFor="about" className="f-600">Remark</label>
              <Form.Control
                as="textarea"
                rows={3}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter Remark"
                className="Dark-Input-from-group"
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button className={`btn btn-danger apply-job me-2 ${!formChanged ? "disabled" : ""}`} onClick={ScheduleInterviewAsInst} disabled={!formChanged}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>

      {/* Cancel Confirmation Modal */}
      <Modal show={showCancelModal} onHide={handleCloseCancelModal} centered>
        <Modal.Header>
          <Modal.Title>Cancel Confirmation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseCancelModal} />
        </Modal.Header>
        <Modal.Body><p>Are you sure, you want to Proceed this action?</p></Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseCancelModal}>Cancel</button>
          <button className="btn btn-danger" onClick={RejectApplication}>Confirm</button>
        </Modal.Footer>
      </Modal>

      {/* Reject Institute Confirmation Modal */}
      <Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
        <Modal.Header>
          <Modal.Title>Reject Confirmation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseRejectModal} />
        </Modal.Header>
        <Modal.Body><p>Are you sure you want to Reject this Application?</p></Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={RejectApplicationAsInst}>Confirm Cancel</button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <Modal show={showConfirmationModal} onHide={handleCancelConfirm} centered>
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCancelConfirm} />
        </Modal.Header>
        <Modal.Body><p>Are you sure you want to do?</p></Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              if (applicationStatus === "Hired") AcceptInterviewApplicationAsInst(instituteAppData.jbApplctnId, "Hired");
              else if (applicationStatus === "Blocked") AcceptInterviewApplicationAsInst(instituteAppData.jbApplctnId, "Blocked");
              else if (applicationStatus === "Rejected") AcceptInterviewApplicationAsInst(instituteAppData.jbApplctnId, "Rejected");
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>

      {/* History Modal */}
      <Modal show={showHistoryModal} onHide={handleCloseHistoryModal} centered>
        <Modal.Header>
          <Modal.Title>Job History</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseHistoryModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          {jobHistory && jobHistory.length > 0 ? (
            jobHistory.map((data, index) => (
              <div className="profile-resume-user-acvtivity mt-4" key={index}>
                <div className="d-flex justify-content-between mb-2 align-center">
                  <div className="d-flex align-items-center">
                    <div
                      className={`profile-resume-applied-status me-2 ${
                        data.hiringStatus === 1 || data.hiringStatus === 9
                          ? "profile-resume-initial-icon"
                          : data.hiringStatus === 5
                          ? "profile-resume-cv-icon"
                          : data.hiringStatus === 4 || data.hiringStatus === 6
                          ? "profile-resume-success-icon"
                          : ""
                      }`}
                    ></div>
                    <div className="profile-resume-applied-jobs f-16 f-700">Hiring Status: {data.hiringStatusName}</div>
                  </div>
                  <div className="profile-resume-user-activity-time f-14 f-400">
                    <span className="f-600">{moment.utc(data.time).local().format("DD MMM YYYY - hh:mm A")}</span>
                  </div>
                </div>
                <div className="profile-resume-user-actvity-container mb-3">
                  {data.remark === "" ? "" : (
                    <p className="f-14 f-400 mb-1"><span className="f-600">Remark:</span> {data.remark}</p>
                  )}
                  {data.scheduledInterviewInfo === null ? "" : (
                    <>
                      <h6 className="f-600 mb-1"><u>Interview Details</u></h6>
                      {data.scheduledInterviewInfo.placeDetails === null ? "" : (
                        <p className="f-14 f-400 mb-1"><span className="f-600">Location:</span> {data.scheduledInterviewInfo.placeDetails}</p>
                      )}
                      {data.scheduledInterviewInfo.remark === null ? "" : (
                        <p className="f-14 f-400 mb-1"><span className="f-600">Remark:</span> {data.scheduledInterviewInfo.remark}</p>
                      )}
                      {data.scheduledInterviewInfo.placeType === null ? "" : (
                        <p className="f-14 f-400 mb-1"><span className="f-600">Place Type:</span> {data.scheduledInterviewInfo.placeType}</p>
                      )}
                      {data.scheduledInterviewInfo.scheduleTime === null ? "" : (
                        <div className="profile-resume-pdf-text f-14 f-500 d-conntents">
                          <CalendarMonthSharpIcon className="me-1" /> Date: {moment.utc(data.scheduledInterviewInfo.scheduleTime).local().format("DD MMM YYYY - hh:mm A")}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>No job history available.</p>
          )}
        </Modal.Body>
      </Modal>

      {/* Job Info Modal */}
      <Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
        <Modal.Header>
          <Modal.Title>Job Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className="mb-3">
            {jobInfo.title === "" ? "" : <p><span className="f-600">Title:</span> {jobInfo.title}</p>}
            {jobInfo.compName === null ? "" : <p><span className="f-600">Company:</span> {jobInfo.compName}</p>}
            {jobInfo.cityName === null ? "" : <p><span className="f-600">City:</span> {jobInfo.cityName}</p>}
            {jobInfo.designationName === null ? "" : <p><span className="f-600">Designation:</span> {jobInfo.designationName}</p>}
            {jobInfo.workLocationTypeName === null ? "" : <p><span className="f-600">Work Location:</span> {jobInfo.workLocationTypeName}</p>}
            {jobInfo.description === "" ? "" : (
              <p>
                <strong>Description:</strong>
                <div dangerouslySetInnerHTML={{ __html: linkifyContent(addTargetBlankToAnchors(jobInfo.description)) }}></div>
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Link to={`/job/${jobInfo?.jobId}`} className="btn khojPrimaryBtn me-2">View</Link>
        </Modal.Footer>
      </Modal>

      {/* Unauthorized Modal */}
      {unAuthorizeError && (
        <Modal show={unauthModal} centered>
          <Modal.Header>
            <Modal.Title>Unauthorized session expired</Modal.Title>
          </Modal.Header>
          <Modal.Body className="settings">
            <div className="mb-3"><p>{unAuthorizeError}</p></div>
          </Modal.Body>
          <Modal.Footer>
            <Link
              className="pointer"
              to="/Login"
              onClick={() => {
                localStorage.removeItem("token");
                sessionStorage.removeItem("sessionId");
                localStorage.removeItem("Module");
              }}
            >
              <button className="btn btn-danger">Login</button>
            </Link>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default RecentApplicants;

// import React, { useEffect, useState } from "react";
// import { Modal, Col, Form } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "../../API/axios";
// import ReactSelect from "react-select";
// import toast from "react-hot-toast";
// import { ChevronDown } from "react-feather";
// import DataTable from "react-data-table-component";
// import moment from "moment";
// import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
// import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import Flatpickr from "react-flatpickr";
// import CheckSharpIcon from "@mui/icons-material/CheckSharp";
// import ClearSharpIcon from "@mui/icons-material/ClearSharp";
// import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
// import Tooltip from "@mui/material/Tooltip";
// import SearchIcon from "@mui/icons-material/Search";
// import HistorySharpIcon from "@mui/icons-material/HistorySharp";
// import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
// import DoneIcon from "@mui/icons-material/Done";
// import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
// import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
// // import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';
// import { ShimmerDiv } from "shimmer-effects-react";
// import error from "../../assets/images/Not-Found.png";
// import { customStyles } from "../../selectStyles";


// const RecentAplicants = ({ userType }) => {
//   const sessionId = localStorage.getItem("sessionId");
//   const [isLoading, setIsLoading] = useState(true);
//   const [isError, setIsError] = useState(false);
//   const [instituteId, setInstituteId] = useState("");
//   const [instituteAppData, setInstituteAppData] = useState("");


//   const [currentPage, setCurrentPage] = useState(0);
//   const [candidateList, setCandidateList] = useState([]);

//   const [totalRows, setTotalRows] = useState(1);
//   const [jobAppInfoData, setJobAppInfoData] = useState("");
//   console.log("jobAppInfoData", jobAppInfoData);

//   // ..................................................................................

//   const [showAppliedModal, setShowAppliedModal] = useState(false);
//   const handleShowModal = () => setShowAppliedModal(true);
//   const handleCloseModal = () => setShowAppliedModal(false);

//   const [showAppliedModalScheule, setShowAppliedModalScheule] = useState(false);

//   const handleCloseModalScheule = () => setShowAppliedModalScheule(false);

//   // Handlers to open and close the modal
//   const [showInstModal, setShowInstModal] = useState(false);
//   const handleInstModal = () => setShowInstModal(true);
//   const handleCloseInstModal = () => setShowInstModal(false);

//   // ..................................................................................
//   // ..................................................................................

//   // ..................................................................................

//   const [showCancelModal, setShowCancelModal] = useState(false); // State for cancel modal


//   const [reload, setReload] = useState(false);

//   const handleCancel = () => {
//     setShowCancelModal(true);
//   };
//   const handleCloseCancelModal = () => {
//     setShowCancelModal(false);
//   };

//   const [showRejectModal, setShowRejectModal] = useState(false);
//   const handleReject = () => {
//     setShowRejectModal(true);
//   };
//   const handleCloseRejectModal = () => {
//     setShowRejectModal(false);
//   };
//   // ...............................................GetAll ...........................................

//   const JobAppGetAll = async (page) => {
// 	setCurrentPage(page)
// 	try {
// 	  setIsLoading(true);
  
// 	  const requestBody = {
// 		sessionId: sessionId,
// 		pageNumber: page,
// 		pageSize: 10,
// 	  };
  
// 	  const response = await axios.post(
// 		`/JobApplication/GetAll?ts=${Date.now()}`,
// 		requestBody,
// 		{
// 		  headers: {
// 			'Cache-Control': 'no-cache',
// 			Pragma: 'no-cache',
// 			Expires: '0',
// 		  },
// 		}
// 	  );
  
// 	  const res = response?.data?.responseData || {};
// 	  console.log("hiring status", res);
  
// 	  setCandidateList(res?.jobApplications || []);
// 	  setTotalRows(res?.paging?.totalrecords || 1);
  
// 	  setIsError(!(res?.jobApplications?.length > 0));
// 	} catch (err) {
// 	  console.error("Error fetching jobs:", err);
// 	  setIsError(true);
// 	  if (err.response?.status === 409) {
// 		setUnAuthorizeError(err.response.data.message);
// 		handleunauthModal();
// 	  }
// 	} finally {
// 	  setIsLoading(false);
// 	}
//   };
  

  

//   useEffect(() => {
//     JobAppGetAll(1);
//   }, []);

//   const [unAuthorizeError, setUnAuthorizeError] = useState("");
//   const [unauthModal, setUnauthModal] = useState(false);
//   const handleunauthModal = () => setUnauthModal(true);
//   const handlecloseunauthModal = () => setUnauthModal(false);

//   // ...............................................Institute Candidate HiringStatus ...........................................

//   const [hiringStatuses, setHiringStatuses] = useState({});
//   const [hiringStatusvalue, setHiringStatusvalue] = useState({});
//   const [candData, setCandData] = useState("");
//   // console.log("hiringStatusvalue", hiringStatuses, hiringStatusvalue);

//   // ...............................................GetInfo...........................................

//   const [jobAppId, setjobAppId] = useState(0);

//   const [candidateId, setCandidateId] = useState(null);
//   const getJobAppInfo = async () => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: jobAppId,
//       };

//       const response = await axios.post("/JobApplication/GetInfo", requestBody);
//       setJobAppInfoData(response.data.responseData);
//     } catch (error) {
//       console.error("API Error:", error);
//     }
//   };

//   // ...............................................RejectApllication...........................................
//   const RejectApplication = async () => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: jobAppId,
//         hiringStatus: "Rejected",
//         remark: "",
//       };
//       const response = await axios.post(
//         "/JobApplication/UpdateHiringStatus",
//         requestBody
//       );

//       if (response.data && response.data.status === "Warning") {
//         toast.warning(response.data.message);
//       } else if (response.data) {
//         toast.success(response.data.message);
//       } else {
//         toast.error("Unexpected response from server");
//       }
//       // toast.success(response.data.message);
//       setJobAppInfoData(response.data);
//       JobAppGetAll();
//       //getGetAllCandidate();
//       handleCloseCancelModal();
//     } catch (error) {
//       console.error("API Error:", error);

//       if (error.response) {
//         toast.error(error.response.data?.message);
//       } else {
//         toast.error("Network error, please try again");
//       }
//     }
//   };

//   // ...............................................Hold ...........................................

//   const HoldApplication = async (id) => {
// 	try {
// 	  const requestBody = {
// 		sessionId: sessionId,
// 		jbApplctnId: id,
// 	  };
  
// 	  const response = await axios.post(
// 		"/JobApplication/HoldJobApplication",
// 		requestBody
// 	  );

// 	  setJobAppInfoData(response.data);
  
// 	  toast.success(response.data.message);
  
// 	  await new Promise(resolve => setTimeout(resolve, 500));
  
// 	  await JobAppGetAll(currentPage);
  
// 	} catch (error) {
// 	  console.error("API Error:", error);
// 	  toast.error(error?.response?.data?.message || "Something went wrong");
// 	}
//   };
  
  

//   // ...............................................UnHold ...........................................
//   const UnHoldApplication = async (id) => {
// 	try {
// 	  // Optimistically update UI first
// 	  setCandidateList(prev =>
// 		prev.map(item =>
// 		  item.jbApplctnId === id
// 			? { ...item, status: 'active' } // Adjust 'status' field name based on your data structure
// 			: item
// 		)
// 	  );
  
// 	  const requestBody = {
// 		sessionId: sessionId,
// 		jbApplctnId: id,
// 	  };
  
// 	  // Make the unhold request with cache prevention
// 	  const response = await axios.post(
// 		"/JobApplication/UnHoldJobApplication",
// 		requestBody,
// 		{
// 		  headers: {
// 			'Cache-Control': 'no-cache',
// 			Pragma: 'no-cache',
// 			Expires: '0',
// 		  },
// 		}
// 	  );
  
// 	  // Handle different response scenarios
// 	  if (response.data?.status === "Warning") {
// 		toast.warning(response.data.message);
// 	  } else if (response.data) {
// 		toast.success(response.data.message);
// 	  } else {
// 		throw new Error("Unexpected response from server");
// 	  }

// 	  setJobAppInfoData(response.data.status);

// 	  await new Promise(resolve => setTimeout(resolve, 500));
  
// 	  await JobAppGetAll(currentPage);
// 	//   setReload(prev => !prev);
  
// 	} catch (error) {
// 	  console.error("API Error:", error);
// 	  // Revert optimistic update on error by refreshing data
// 	  await JobAppGetAll(currentPage);
// 	  toast.error(error?.response?.data?.message || "Something went wrong");
// 	}
//   };
  

//   // ...................................................AcceptApplication..........................................

//   const AcceptApplication = async (id) => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: id,
//         hiringStatus: "Shortlisted",
//         remark: "",
//       };
//       const response = await axios.post(
//         "/JobApplication/UpdateHiringStatus",
//         requestBody
//       );

//       if (response.data && response.data.status === "Warning") {
//         toast.warning(response.data.message);
//       } else if (response.data) {
//         toast.success(response.data.message);
//       } else {
//         toast.error("Unexpected response from server");
//       }

//       JobAppGetAll();
//       getGetAllCandidate();
//     } catch (error) {
//       console.error("API Error:", error);

//       if (error.response) {
//         toast.error(error.response.data?.message);
//       } else {
//         toast.error("Network error, please try again");
//       }
//     }
//   };
//   // ...................................................AcceptApplicationAsInstitute..........................................

//   const AcceptApplicationAsInst = async (cnddtId) => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: instituteAppData.jbApplctnId,
//         hiringStatus: "Shortlisted",
//         remark: "",
//         insttUid: instituteAppData.userUid,
//         cnddtID: cnddtId,
//         grpTypName: instituteAppData.grpTypName,
//         grpTypeId: instituteAppData.grpTypeId,
//       };

//       const response = await axios.post(
//         "/JobApplication/UpdateHiringStatusForInstituteCandidates",
//         requestBody
//       );

//       toast.success(response.data.message);
//       JobAppGetAll();
//       getGetAllCandidate();
//       InstituteCandidateHiringStatus(candData);
//     } catch (error) {
//       toast.error(error.response);
//       console.error("API Error:", error);
//     }
//   };

//   // ...............................................RejectApplicationAsInst...........................................
//   const RejectApplicationAsInst = async () => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: instituteAppData.jbApplctnId,
//         hiringStatus: "Rejected",
//         remark: "",
//         insttUid: instituteAppData.userUid,
//         cnddtID: candidateId,
//         grpTypName: instituteAppData.grpTypName,
//         grpTypeId: instituteAppData.grpTypeId,
//       };
//       const response = await axios.post(
//         "/JobApplication/UpdateHiringStatusForInstituteCandidates",
//         requestBody
//       );
//       setJobAppInfoData(response.data);
//       handleCloseRejectModal();
//       getGetAllCandidate();
//       InstituteCandidateHiringStatus(candData);
//       toast.success(response.data.message);
//     } catch (error) {
//       console.error("API Error:", error);
//     }
//   };

//   // ...................................................ScheduleInterview..........................................

//   const [scheduleTime, setScheduleTime] = useState("");
//   const [placeType, setPlaceType] = useState(null);
//   const [placeDetails, setPlaceDetails] = useState("");
//   const [remark, setRemark] = useState("");

//   const ScheduleInterview = async () => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: jobAppId,
//         scheduleTime: scheduleTime,
//         placeType: parseInt(placeType, 10), // Ensure it's a number
//         placeDetails: placeDetails,
//         remark: remark,
//       };
//       const response = await axios.post(
//         "/JobApplication/ScheduleInterview",
//         requestBody
//       );
//       console.log("requestBodyScheduleInterview", requestBody);

//       toast.success(response.data.message);
//       JobAppGetAll();
//       handleCloseModal(); // Close modal on success
//       setScheduleTime(null);
//       setPlaceType("");
//       setPlaceDetails("");
//       setRemark("");
//     } catch (error) {
//       toast.error(error.data.message);
//       console.error("API Error:", error);
//     }
//   };

//   const ScheduleInterviewAsInst = async () => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: instituteAppData.jbApplctnId,
//         scheduleTime,
//         placeType: parseInt(placeType, 10), // Ensure it's a number
//         placeDetails,
//         remark,
//         insttUid: instituteAppData.userUid,
//         cnddtID: candidateId,
//         grpTypName: instituteAppData.grpTypName,
//         grpTypeId: instituteAppData.grpTypeId,
//       };

//       const response = await axios.post(
//         "/JobApplication/ScheduleInterviewForInstituteCandidates",
//         requestBody
//       );

//       toast.success(response.data.message);
//       JobAppGetAll();
//       handleCloseModal(); // Close modal on success
//       handleCloseModalScheule();
//       setScheduleTime("");
//       setPlaceType(null);
//       setPlaceDetails("");
//       setRemark("");
//       InstituteCandidateHiringStatus(candData);
//     } catch (error) {
//       toast.error(error.data.message);
//       toast.error("Some problem occurred!");
//       console.error("API Error:", error);
//     }
//   };

//   // ...............................................................................................................

//   // ........................................Job History start..........................

//   const [jobHistory, setJobHistory] = useState("");
//   const [showHistoryModal, setShowHistoryModal] = useState(false);
//   const handleHistoryShow = () => setShowHistoryModal(true);
//   const handleCloseHistoryModal = () => setShowHistoryModal(false);

//   const JobHistory = async (id, candidateId) => {
//     const data = {
//       sessionId: sessionId,
//       jbApplctnId: id,
//       cnddtID: candidateId ? candidateId : null,
//     };
//     console.log("data22", data);
//     try {
//       await axios.post("/JobApplication/GetHistory", data).then((resData) => {
//         console.log("HISTORY", resData.data.responseData);
//         const data = resData.data.responseData;
//         setJobHistory(data);
//       });
//     } catch (e) {
//       console.log("Unapply ");
//     }
//   };

//   // ........................................Job History End..........................

//   // ........................................Job info start..........................

//   const [jobInfo, setJobInfo] = useState("");
//   const [showInfoModal, setShowInfoModal] = useState(false);
//   const handleInfoShow = () => setShowInfoModal(true);
//   const handleCloseInfoModal = () => setShowInfoModal(false);

//   const JobInfoData = (JobId) => {
//     axios
//       .get(`/Job/GetJobDetails?JobId=${JobId}`)
//       .then((response) => {
//         const res = response.data.responseData;
//         setJobInfo(res);
//         console.log("edit data", res);
//       })
//       .catch((error) => {
//         if (error.response && error.response.status === 404) {
//           console.log(error);
//         } else {
//           console.log(error);
//         }
//       });
//   };

//   const columns = [
//     {
//       name: "CANDIDATES",
//       sortable: true,
//       center: true,
//       cell: (row) => (
//         <div
//           className="mt-2 mb-2 candidate-main-section"
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             gap: "5px",
//           }}
//         >
//           {/* Row for Image and Username */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexDirection: "column",
//               gap: "10px",
//             }}
//           >
//             {/* User Image */}
//             <img
//               src={row.userProfilePic}
//               alt="User"
//               style={{ width: "50px", height: "50px", borderRadius: "50%" }}
//             />
//             <div className="pointer">{row.userName}</div>
//           </div>

//           <div className="job-footer-left">
//             <ul className="job-tag mb-0" style={{ margin: 0, padding: 0 }}>
//               {row.jbApplctnTypeName === "Candidate" ? (
//                 <>
//                   <Link to={`/Candidate/${row.userUid}`}>
//                     <li className="mb-0">{row.jbApplctnTypeName}</li>
//                   </Link>
//                 </>
//               ) : (
//                 <>
//                   <Link to={`/Institution/${row.userUid}`}>
//                     <li className="mb-0">{row.jbApplctnTypeName}</li>
//                   </Link>
//                 </>
//               )}
//             </ul>
//           </div>
//           <div className="pointer tdm-Candid">
//             {moment
//               .utc(row.appliedTime)
//               .local()
//               .format("DD MMM YYYY - HH:mm A")}
//           </div>
//         </div>
//       ),
//     },
//     {
//       name: "JOB NAME",
//       center: true,
//       sortable: true,
//       // minWidth: "150px",
//       cell: (row) => (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             gap: "5px",
//             alignItems: "center",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <div
//               className="pointer jobinfo f-600 text-center"
//               onClick={() => {
//                 handleInfoShow();
//                 JobInfoData(row.jobId);
//               }}
//             >
//               {row.jobTitle} <span></span>
//             </div>
//           </div>
//           {/* <div className="text-center"
// 					dangerouslySetInnerHTML={{
// 						__html: linkifyContent(
// 							addTargetBlankToAnchors(row.shortDescription)
// 						)
// 					}}
// 					> 
// 						</div> */}
//         </div>
//       ),
//       // selector: (row) => row.jobTitle,
//     },

//     {
//       name: "STATUS",
//       center: true,
//       sortable: true,
//       // minWidth: "150px",
//       cell: (row) => (
//         <>
//           {row.jbApplctnType === 2 ? (
//             row.hiringStatus === 9 ? (
//               <div className="job-footer-left ">
//                 <ul style={{ margin: 0, padding: 0 }}>
//                   <li>{row.hiringStatusName}</li>
//                 </ul>
//               </div>
//             ) : (
//               <div className="job-footer-left">
//                 <ul className="green" style={{ margin: 0, padding: 0 }}>
//                   <li>{row.hiringStatusName}</li>
//                 </ul>
//               </div>
//             )
//           ) : (
//             <div
//               style={{ display: "flex", flexDirection: "column", gap: "5px" }}
//             >
//               {row.hiringStatus === 0 ? (
//                 <div className="job-footer-left">
//                   <ul className="red" style={{ margin: 0, padding: 0 }}>
//                     <li>{row.hiringStatusName}</li>
//                   </ul>
//                 </div>
//               ) : row.hiringStatus === 1 ? (
//                 <div className="job-footer-left">
//                   <ul style={{ margin: 0, padding: 0 }}>
//                     <li>{row.hiringStatusName}</li>
//                   </ul>
//                 </div>
//               ) : row.hiringStatus === 5 ? (
//                 <div className="job-footer-left">
//                   <ul className="orange" style={{ margin: 0, padding: 0 }}>
//                     <li>{row.hiringStatusName}</li>
//                   </ul>
//                 </div>
//               ) : row.hiringStatus === 7 || row.hiringStatus === 8 ? (
//                 <div className="job-footer-left">
//                   <ul className="red" style={{ margin: 0, padding: 0 }}>
//                     <li>{row.hiringStatusName}</li>
//                   </ul>
//                 </div>
//               ) : (
//                 <div className="job-footer-left">
//                   <ul className="green" style={{ margin: 0, padding: 0 }}>
//                     <li>{row.hiringStatusName}</li>
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}

//           <span className="ms-2">
//             <Tooltip title="History" arrow>
//               <HistorySharpIcon
//                 onClick={() => {
//                   handleHistoryShow();
//                   JobHistory(row.jbApplctnId);
//                 }}
//                 className="pointer mt-0"
//               />
//             </Tooltip>
//           </span>
//         </>
//       ),
//     },
//     {
//       name: "ACTION",
//       center: true,
//       // minWidth: "300px",
//       cell: (row) => {
//         const isDisabled = row.hiringStatus === 11;
//         {
//           console.log("status", row.hiringStatus);
//         }
//         return (
//           <>
//             {row.jbApplctnType === 2 ? (
//               <>
//                 <Tooltip title="Candidate List" arrow>
//                   <PeopleSharpIcon
//                     className="pointer blueIcon"
//                     onClick={() => {
//                       setjobappId(row.jbApplctnId);
//                       setjobappNameId(row.jbApplctnTypeName);
//                       setInstituteId(row.userUid);
//                       setInstituteAppData(row);
//                       setTimeout(() => {
//                         handleInstModal();
//                       }, 100);
//                     }}
//                   />
//                 </Tooltip>
//               </>
//             ) : (
//               <div>
//                 {row.hiringStatus === 6 ||
//                 row.hiringStatus === 7 ||
//                 row.hiringStatus === 8 ? (
//                   ""
//                 ) : row.hiringStatus === 5 ? (
//                   <Link to={`/Interviews`}>
//                     <span className="text-warning f-14 f-700 pointer">
//                       Go to Interview
//                     </span>
//                   </Link>
//                 ) : (
//                   <>
//                     {row?.hiringStatus === 4 || row.hiringStatus === 11 ? (
//                       <>
//                         <span className="">
//                           <Tooltip title="Schedule" arrow>
//                             <CalendarMonthSharpIcon
//                               className={`pointer calendarIcon ${
//                                 isDisabled ? "disabled-icon" : ""
//                               }`}
//                               onClick={() => {
//                                 handleShowModal();
//                                 setjobAppId(row.jbApplctnId);
//                               }}
//                             />
//                           </Tooltip>
//                         </span>
//                         {isDisabled ? (
//                           <span className="ms-2">
//                             <Tooltip title="UnHold" arrow>
//                               <Link
//                                 onClick={() => {
//                                   UnHoldApplication(row.jbApplctnId);
//                                 }}
//                               >
//                                 <PauseCircleFilledIcon className="blueIcon" />
//                               </Link>
//                             </Tooltip>
//                           </span>
//                         ) : (
//                           <span className="ms-2">
//                             <Tooltip title="Hold" arrow>
// 							<Link
// 								onClick={
// 									isDisabled
// 									? undefined
// 									: async () => {
// 										await HoldApplication(row.jbApplctnId);
// 										}
// 								}
// 								>
//                                 <PauseCircleOutlineIcon
//                                   className={`blueIcon `}
//                                 />
//                               </Link>
//                             </Tooltip>
//                           </span>
//                         )}
//                       </>
//                     ) : (
//                       <>
//                         {row.hiringStatusName !== "Withdraw" ? (
//                           <span className="ms-2">
//                             <Tooltip title="Shortlist" arrow>
//                               <CheckSharpIcon
//                                 className={`pointer checkIcon ${
//                                   isDisabled ? "disabled-icon" : ""
//                                 }`}
//                                 onClick={
//                                   isDisabled
//                                     ? undefined
//                                     : () => {
//                                         AcceptApplication(row.jbApplctnId);
//                                       }
//                                 }
//                               />
//                             </Tooltip>
//                           </span>
//                         ) : null}
//                       </>
//                     )}
//                     <>
//                       {row.hiringStatusName !== "Withdraw" ? (
//                         <span className="ms-2">
//                           <Tooltip title="Reject" arrow>
//                             <ClearSharpIcon
//                               // className="pointer rejectIcon"
//                               className={`pointer rejectIcon ${
//                                 isDisabled ? "disabled-icon" : ""
//                               }`}
//                               onClick={() => {
//                                 handleCancel();
//                                 setjobAppId(row.jbApplctnId);
//                               }}
//                             />
//                           </Tooltip>
//                         </span>
//                       ) : null}
//                     </>

//                     <span className=" ms-2">
//                       <Tooltip title="View resume " arrow>
//                         <Link
//                           target="blank"
//                           to={`/Resume/Candidate?userUID=${row.userUid}`}
//                           // to={`/Candidate/${row.userUid}`}
//                         >
//                           <VisibilitySharpIcon className="blueIcon" />
//                         </Link>
//                       </Tooltip>
//                     </span>

//                     {/* <span className="ms-2 ">
// 										<Tooltip title="Test Assign" arrow>
											 
// 												<AssignmentSharpIcon
// 													onClick={() => {
// 														handleTestShow();
// 														setCandidateId(row.userUid);
// 														 setjobappId(row.jbApplctnId);
// 														 setjobappNameId(row.jbApplctnTypeName)
// 													}}
// 													className="blueIcon" /> 
// 										</Tooltip>
// 									   </span>  */}
//                   </>
//                 )}
//               </div>
//             )}
//           </>
//         );
//       },
//     },
//   ];

//   // ..............................................Test Assign actions.................................................................

//   const [showModal, setShowRemarkModal] = useState(false);

//   const [jobappId, setjobappId] = useState("");
//   const [jobappNameId, setjobappNameId] = useState("");

//   const [showConfirmationModal, setShowConfirmationModal] = useState(false);
//   const handleCancelConfirm = () => {
//     setShowConfirmationModal(false);
//   };

//   const [applicationStatus, setApplicationStatus] = useState("");

//   const AcceptInterviewApplicationAsInst = async (id, hiringStatus) => {
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: id,
//         hiringStatus: hiringStatus,
//         remark: "",
//         insttUid: instituteAppData.userUid,
//         cnddtID: candidateId,
//         grpTypName: instituteAppData.grpTypName,
//         grpTypeId: instituteAppData.grpTypeId,
//       };
//       console.log("AcceptApplication", requestBody);

//       const response = await axios.post(
//         "/JobApplication/UpdateHiringStatusForInstituteCandidates",
//         requestBody
//       );

//       console.log("getAcceptApplication", response);
//       toast.success(response.data.message);

//       // Update the local state with the new hiring status
//       setInstituteAppData((prevData) => ({
//         ...prevData,
//         hiringStatus: hiringStatus,
//       }));
//       JobAppGetAll();
//       InstituteCandidateHiringStatus(instituteAppData);
//       getGetAllCandidate();

//       handleCancelConfirm();
//     } catch (error) {
//       toast.error(error.response);
//       console.error("API Error:", error);
//     }
//   };

//   const Inscolumns = [
//     {
//       name: "CANDIDATES",
//       // center: true,
//       sortable: true,
//       cell: (row) => (
//         <div
//           className="pt-2 pb-2 inst-cacndidate-section"
//           style={{ display: "flex", flexDirection: "column", gap: "5px" }}
//         >
//           <div
//             style={{ display: "flex", alignItems: "center", gap: "5px" }}
//             className="inst-cacndidate-list-style "
//           >
//             <img
//               src={row.profileImage}
//               alt="User"
//               style={{ width: "50px", height: "50px", borderRadius: "50%" }}
//             />
//             <div className="row">
//               <div className=" ">{row.firstName}</div>
//               <div className=" ">{row.lastName}</div>
//             </div>
//           </div>
//         </div>
//       ),
//     },

//     {
//       name: "BATCH NAME",
//       // center: true,
//       sortable: true,
//       // minWidth: "150px",
//       selector: (row) =>
//         Array.isArray(row.insttCandidateProfile.batchNames)
//           ? row.insttCandidateProfile.batchNames.join(", ")
//           : row.insttCandidateProfile.batchNames,
//     },

//     {
//       name: "STATUS",
//       sortable: true,
//       cell: (row) => {
//         const statusValue = hiringStatusvalue[row.cnddtId];
//         const statusText = hiringStatuses[row.cnddtId] || "Applied";

//         let badgeClass = "green";
//         if (statusValue === 1) {
//           badgeClass = "default";
//         } else if (statusValue === 5) {
//           badgeClass = "orange";
//         } else if (statusValue === 7 || statusValue === 8) {
//           badgeClass = "red";
//         }

//         return (
//           <>
//             <div className="react-table-inner-section">
//               <div className={`job-footer-left ${badgeClass}`}>
//                 <ul style={{ margin: 0, padding: 0 }}>
//                   <li>{statusText}</li>
//                 </ul>
//               </div>
//               <span className="ms-2">
//                 <Tooltip title="History" arrow>
//                   <HistorySharpIcon
//                     onClick={() => {
//                       handleHistoryShow();
//                       JobHistory(instituteAppData?.jbApplctnId, row.cnddtId);
//                       setCandidateId(row.cnddtId);
//                     }}
//                     className="pointer mt-0"
//                   />
//                 </Tooltip>
//               </span>
//             </div>
//           </>
//         );
//       },
//     },
//     {
//       name: "ACTION",
//       center: true,
//       cell: (row) => {
//         const statusValue = hiringStatusvalue[row.cnddtId];
//         const isDisabled = statusValue === 11;

//         return (
//           <div>
//             {statusValue === 7 || statusValue === 6 || statusValue === 8 ? (
//               ""
//             ) : statusValue === 5 ? (
//               <Link to={`/Interviews`}>
//                 <span className="text-warning f-14 f-700 pointer">
//                   Go to Interview
//                 </span>
//               </Link>
//             ) : (
//               <>
//                 {statusValue === 4 ? (
//                   <>
//                     <span className="me-2">
//                       <Tooltip title="Schedule" arrow>
//                         <CalendarMonthSharpIcon
//                           className={`pointer ${
//                             isDisabled ? "disabled-icon" : ""
//                           }`}
//                           onClick={
//                             isDisabled
//                               ? undefined
//                               : () => {
//                                   setShowAppliedModalScheule(true);
//                                   setCandidateId(row.cnddtId);
//                                   setCandData(row);
//                                 }
//                           }
//                         />
//                       </Tooltip>
//                     </span>
//                   </>
//                 ) : (
//                   <span className="me-2">
//                     <Tooltip title="Shortlist" arrow>
//                       <DoneIcon
//                         className={`pointer checkIcon ${
//                           isDisabled ? "disabled-icon" : ""
//                         }`}
//                         onClick={
//                           isDisabled
//                             ? undefined
//                             : () => {
//                                 AcceptApplicationAsInst(row.cnddtId);
//                                 InstituteCandidateHiringStatus(row);
//                               }
//                         }
//                       />
//                     </Tooltip>
//                   </span>
//                 )}
//                 <>
//                   <span className="me-2">
//                     <Tooltip title="Reject" arrow>
//                       <ClearSharpIcon
//                         className={`pointer rejectIcon ${
//                           isDisabled ? "disabled-icon" : ""
//                         }`}
//                         onClick={
//                           isDisabled
//                             ? undefined
//                             : () => {
//                                 setShowConfirmationModal(true);
//                                 setApplicationStatus("Rejected");
//                                 setjobAppId(row.jbApplctnId);
//                                 setCandidateId(row.cnddtId);
//                               }
//                         }
//                       />
//                     </Tooltip>
//                   </span>
//                 </>
//                 {/* <span className=""> */}

//                 {/* <Link
// 										target="blank"
// 										// to={`/Resume/${row.cnddtUID}/InstUID/${instituteId}`}
// 										to={`/Resume?userUID=${row.cnddtUID}&InstUID=${instituteId}`}
// 									>
// 										<Tooltip title="View resume" arrow>

// 											<VisibilitySharpIcon className="ViewIcon" />
// 										</Tooltip>
// 									</Link> */}
//                 <Link
//                   target="_blank"
//                   to={`/Resume?userUID=${row.cnddtUID}&InstUID=${instituteId}`}
//                 >
//                   <Tooltip title="View" arrow>
//                     <VisibilitySharpIcon
//                       style={{ cursor: "pointer", color: "black" }}
//                       className="ms-2 joblist-eye-icon Dark-icon-color"
//                     />
//                   </Tooltip>
//                 </Link>
//                 {/* </span> */}
//               </>
//             )}
//           </div>
//         );
//       },
//     },
//   ];

//   const [display, setDisplay] = useState(false);
//   const [search, setSearch] = useState("");
//   const [InsCandidateList, setInsCandidateList] = useState([]);

//   const getGetAllCandidate = async (page) => {
//     const data = {
//       pageNumber: page,
//       pageSize: 10,
//     };

//     try {
//       const response = await axios.post(
//         `/Candidate/GetAllByInstt/${instituteId}?Type=${instituteAppData.grpTypName}&TypeId=${instituteAppData.grpTypeId}&Search=${search}`,
//         data
//       );
//       const res = response.data.responseData.items;

//       console.log("Candidate response:", data);
//       setInsCandidateList(res);
//       setIsLoading(false);
//       if (res.length > 0) {
//         await Promise.all(
//           res.map((candidate) => InstituteCandidateHiringStatus(candidate))
//         );
//       }

//       setDisplay(false);
//     } catch (e) {
//       console.error("Error fetching candidates:", e);
//       if (e.response && e.response.status === 404) {
//         setDisplay(true);
//       }
//     }
//   };

//   const InstituteCandidateHiringStatus = async (candidate) => {
//     if (!candidate || !candidate.cnddtId) {
//       console.log("candidate", candidate);
//       return;
//     }
//     try {
//       const requestBody = {
//         sessionId: sessionId,
//         jbApplctnId: instituteAppData?.jbApplctnId,
//         insttUid: instituteAppData?.userUid,
//         cnddtID: candidate?.cnddtId,
//         grpTypName: instituteAppData?.grpTypName,
//         grpTypeId: instituteAppData?.grpTypeId,
//       };
//       const response = await axios.post(
//         "/JobApplication/GetInstituteCandidateHiringStatus",
//         requestBody
//       );
//       console.log("response status", response.data.responseData);
//       const hiringStatusName =
//         response.data.responseData.hiringStatusName || "Applied";
//       const hiringStatusValue = response.data.responseData.hiringStatus || 0;
//       setHiringStatuses((prev) => ({
//         ...prev,
//         [candidate.cnddtId]: hiringStatusName,
//       }));

//       setHiringStatusvalue((prev) => ({
//         ...prev,
//         [candidate.cnddtId]: hiringStatusValue,
//       }));
//     } catch (error) {
//       console.error("Error fetching hiring statuses:", error);
//     }
//   };

//   useEffect(() => {
//     if (candData && Array.isArray(candData)) {
//       candData.forEach((candidate) => {
//         InstituteCandidateHiringStatus(candidate);
//       });
//     }
//   }, [candData, hiringStatuses, hiringStatusvalue]);

//   // useEffect for triggering candidate fetch based on instituteId or search
//   useEffect(() => {
//     if (instituteId || search) {
//       getGetAllCandidate();
//     }
//   }, [instituteId, search]);

//   // .................................shortDescription
//   const addTargetBlankToAnchors = (html) => {
//     const div = document.createElement("div");
//     div.innerHTML = html;

//     const anchors = div.querySelectorAll("a");
//     anchors.forEach((anchor) => {
//       anchor.setAttribute("target", "_blank");
//       anchor.setAttribute("rel", "noopener noreferrer");
//     });

//     return div.innerHTML;
//   };

//   const linkifyContent = (htmlContent) => {
//     const urlPattern =
//       /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
//     return htmlContent.replace(urlPattern, function (url) {
//       return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//     });
//   };
//   // .................................shortDescription

//   // .............................................
//   const [formChanged, setFormChanged] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleFieldChange = (setter, value, fieldName) => {
//     setter(value);

//     // Updated values
//     const updatedScheduleTime =
//       fieldName === "scheduleTime" ? value : scheduleTime;
//     const updatedPlaceType = fieldName === "placeType" ? value : placeType;
//     const updatedPlaceDetails =
//       fieldName === "placeDetails" ? value : placeDetails;

//     // Check if all required fields are filled

//     // Check if all required fields are filled
//     const allFieldsFilled =
//       updatedScheduleTime &&
//       updatedPlaceType !== "0" && // Ensure a valid option is selected
//       updatedPlaceDetails.trim() !== "";

//     setFormChanged(allFieldsFilled);
//   };

//   return (
//     <>
//       <section className="pricing-section-three container jobapplication application-drop-section">
//         <div className="row">
//           <div className="delete-title mb-1 col-md-6">
//             <h1 className="orange-title">
//               <span className="orange-box me-2"></span>
//               Manage Applications
//             </h1>
//           </div>
//           <div className="mb-1 col-6 text-start"></div>
//         </div>
//         <div className="container st3">
//           <div className="row">
//             <div className="col-lg-12">
//               {isLoading ? (
//                 <div className="row mt-2">
//                   <div className="col-md-12">
//                     <ShimmerDiv mode="light" height={100} width={"100%"} />
//                   </div>
//                   <div className="col-md-12 mt-2">
//                     <ShimmerDiv mode="light" height={100} width={"100%"} />
//                   </div>
//                   <div className="col-md-12 mt-2">
//                     <ShimmerDiv mode="light" height={100} width={"100%"} />
//                   </div>
//                   <div className="col-md-12 mt-2">
//                     <ShimmerDiv mode="light" height={100} width={"100%"} />
//                   </div>
//                 </div>
//               ) : isError || candidateList.length === 0 ? (
//                 <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
//                   {/* <img src='/' alt="404 Not Found" width={200} /> */}
//                   <img src={error} alt="404 Not Found" width={300} />
//                 </div>
//               ) : (
//                 <div className="table-res d-flex">
//                   <div className="react-dataTable react-table-colorclass react-table-section">
//                     <DataTable
//                       noHeader
//                       pagination
//                       columns={columns}
//                       data={candidateList}
//                       progressPending={isLoading}
//                       paginationServer
//                       paginationPerPage={10}
//                       paginationTotalRows={totalRows}
//                       paginationRowsPerPageOptions={[]}
// 					  paginationDefaultPage={currentPage}
//                       onChangePage={(page) => {
//                         JobAppGetAll(page);
//                       }}
//                       sortIcon={<ChevronDown size={10} />}
//                       className="react-dataTable"
//                     />
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* UerInfo Modal */}
//       <Modal
//         show={showInstModal}
//         onHide={handleCloseInstModal}
//         centered
//         size="xl"
//       >
//         <Modal.Header>
//           <Modal.Title> Institute candidate details</Modal.Title>
//           <CloseSharpIcon
//             className="pointer"
//             onClick={() => {
//               handleCloseInstModal();
//               setInstituteId("");
//               setInstituteAppData("");
//               setInsCandidateList([]);
//             }}
//           />
//         </Modal.Header>
//         <Modal.Body className="settings jobapplication">
//           <div className="container st3">
//             <div className="row">
//               <div className="col-lg-12">
//                 <div className="manage-search-bar">
//                   <SearchIcon className="icon" />
//                   <input
//                     type="text"
//                     placeholder="Search Candidates"
//                     className="manage-search-input Dark-Manage-Search"
//                     onChange={(e) => setSearch(e.target.value)}
//                   />
//                 </div>
//                 {isLoading ? (
//                   <div className="row mt-2">
//                     <div className="col-md-12">
//                       <ShimmerDiv mode="light" height={100} width={"100%"} />
//                     </div>
//                     <div className="col-md-12 mt-2">
//                       <ShimmerDiv mode="light" height={100} width={"100%"} />
//                     </div>
//                     <div className="col-md-12 mt-2">
//                       <ShimmerDiv mode="light" height={100} width={"100%"} />
//                     </div>
//                     <div className="col-md-12 mt-2">
//                       <ShimmerDiv mode="light" height={100} width={"100%"} />
//                     </div>
//                   </div>
//                 ) : isError ? (
//                   <div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
//                     <img src={error} alt="404 Not Found" width={300} />
//                     {/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
//                   </div>
//                 ) : (
//                   <div className="table-res">
//                     <div className="react-dataTable  react-table-colorclass">
//                       <DataTable
//                         noHeader
//                         pagination
//                         columns={Inscolumns}
//                         paginationPerPage={10}
//                         className="react-dataTabley"
//                         sortIcon={<ChevronDown size={10} />}
//                         paginationDefaultPage={currentPage + 1}
//                         data={InsCandidateList}
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>

//       {/* Modal */}
//       <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
//         <Modal.Header>
//           <Modal.Title>Add Interview Schedule Details</Modal.Title>
//           <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
//         </Modal.Header>
//         <Modal.Body className="settings">
//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="about">
//                 Schedule Time{" "}
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <Flatpickr
//                 data-enable-time
//                 value={scheduleTime}
//                 // onChange={(selectedDates) => {
//                 // 	setScheduleTime(selectedDates[0]);
//                 // }}
//                 onChange={(selectedDates) =>
//                   handleFieldChange(
//                     setScheduleTime,
//                     selectedDates[0],
//                     "scheduleTime"
//                   )
//                 }
//                 options={{
//                   enableTime: true,
//                   dateFormat: "Y-m-d H:i",
//                   minDate: new Date(),
//                   static: true, // Keeps the calendar visible on click
//                 }}
//                 className="form-control Dark-Input-from-group"
//                 placeholder="Enter schedule time"
//               />
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="schedule-time">
//                 Interview Mode Type{" "}
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <select
//                 id="place-type"
//                 // value={placeType}
//                 // onChange={(e) => setPlaceType(e.target.value)}
//                 onChange={(e) =>
//                   handleFieldChange(setPlaceType, e.target.value, "placeType")
//                 }
//                 className="form-control Dark-Input-from-group"
//               >
//                 <option value="0"> Select </option>
//                 <option value="1">OnSite</option>
//                 <option value="2">Remote</option>
//                 <option value="3">Hybrid</option>
//               </select>
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="about">
//                 Place Details{" "}
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <input
//                 type="text"
//                 value={placeDetails}
//                 // onChange={(e) => setPlaceDetails(e.target.value)}
//                 onChange={(e) =>
//                   handleFieldChange(
//                     setPlaceDetails,
//                     e.target.value,
//                     "placeDetails"
//                   )
//                 }
//                 placeholder="Enter place details"
//                 className="form-control Dark-Input-from-group"
//               />
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <Form.Group controlId="description">
//               <label htmlFor="about" className="f-600">
//                 Remark
//               </label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={remark}
//                 onChange={(e) => setRemark(e.target.value)}
//                 placeholder="Enter Remark "
//                 className="Dark-Input-from-group"
//               />
//             </Form.Group>
//           </Col>
//         </Modal.Body>
//         <Modal.Footer>
//           {/* <button
// 						className="btn btn-danger apply-job me-2"
// 						onClick={ScheduleInterview}
// 					>
// 						Submit
// 					</button> */}
//           <button
//             className={`btn btn-danger apply-job me-2 ${
//               !formChanged ? "disabled" : ""
//             }`}
//             onClick={ScheduleInterview}
//             disabled={!formChanged}
//           >
//             Submit
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* Interview schedule */}
//       <Modal
//         show={showAppliedModalScheule}
//         onHide={handleCloseModalScheule}
//         centered
//       >
//         <Modal.Header>
//           <Modal.Title>Add Interview Schedule Details</Modal.Title>
//           <CloseSharpIcon
//             className="pointer"
//             onClick={handleCloseModalScheule}
//           />
//         </Modal.Header>
//         <Modal.Body className="settings">
//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="about">
//                 Schedule Time{" "}
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <Flatpickr
//                 data-enable-time
//                 value={scheduleTime}
//                 // onChange={(selectedDates) => {
//                 // 	setScheduleTime(selectedDates[0]);
//                 // }}
//                 onChange={(selectedDates) =>
//                   handleFieldChange(
//                     setScheduleTime,
//                     selectedDates[0],
//                     "scheduleTime"
//                   )
//                 }
//                 options={{
//                   enableTime: true,
//                   dateFormat: "Y-m-d H:i",
//                   minDate: new Date(),
//                   static: true, // Keeps the calendar visible on click
//                 }}
//                 className="form-control Dark-Input-from-group"
//                 placeholder="Enter schedule time"
//               />
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="schedule-time">
//                 Interview Mode Type
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <select
//                 id="place-type"
//                 // value={placeType}
//                 // onChange={(e) => setPlaceType(e.target.value)}
//                 onChange={(e) =>
//                   handleFieldChange(setPlaceType, e.target.value)
//                 }
//                 className="form-control Dark-Input-from-group"
//               >
//                 <option value="0" disabled hidden>
//                   {" "}
//                   Select{" "}
//                 </option>
//                 <option value="1">OnSite</option>
//                 <option value="2">Remote</option>
//                 <option value="3">Hybrid</option>
//               </select>
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <div className="post-form-group">
//               <label htmlFor="about">
//                 Place Details{" "}
//                 <span style={{ color: "red" }} className="ms-2">
//                   *
//                 </span>
//               </label>
//               <input
//                 type="text"
//                 value={placeDetails}
//                 // onChange={(e) => setPlaceDetails(e.target.value)}
//                 onChange={(e) =>
//                   handleFieldChange(
//                     setPlaceDetails,
//                     e.target.value,
//                     "placeDetails"
//                   )
//                 }
//                 placeholder="Enter place details"
//                 className="form-control Dark-Input-from-group"
//               />
//             </div>
//           </Col>

//           <Col md={12} className="mb-2">
//             <Form.Group controlId="description">
//               <label htmlFor="about" className="f-600">
//                 Remark
//               </label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 className="Dark-Input-from-group"
//                 value={remark}
//                 onChange={(e) => setRemark(e.target.value)}
//                 placeholder="Enter Remark"
//               />
//             </Form.Group>
//           </Col>
//         </Modal.Body>
//         <Modal.Footer>
//           {/* <button
// 						className="btn btn-danger apply-job me-2"
// 						onClick={ScheduleInterviewAsInst}
// 					>
// 						Submit
// 					</button> */}
//           <button
//             className={`btn btn-danger apply-job me-2 ${
//               !formChanged ? "disabled" : ""
//             }`}
//             onClick={ScheduleInterviewAsInst}
//             disabled={!formChanged}
//           >
//             Submit
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* Modal for Cancel Confirmation */}
//       <Modal show={showCancelModal} onHide={handleCloseCancelModal} centered>
//         <Modal.Header>
//           <Modal.Title>Cancel Confirmation</Modal.Title>
//           <CloseSharpIcon
//             className="pointer"
//             onClick={handleCloseCancelModal}
//           />
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure, you want to Proceed this action?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-secondary"
//             onClick={() => {
//               handleCloseCancelModal();
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             className="btn btn-danger"
//             onClick={() => {
//               RejectApplication();
//             }}
//           >
//             Confirm
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* Modal for Reject as institute Confirmation */}
//       <Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
//         <Modal.Header>
//           <Modal.Title>Reject Confirmation</Modal.Title>
//           <CloseSharpIcon
//             className="pointer"
//             onClick={handleCloseRejectModal}
//           />
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to Reject this Application?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-danger"
//             onClick={() => {
//               RejectApplicationAsInst();
//             }}
//           >
//             Confirm Cancel
//           </button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showConfirmationModal} onHide={handleCancelConfirm} centered>
//         <Modal.Header>
//           <Modal.Title>Confirmation</Modal.Title>
//           <CloseSharpIcon className="pointer" onClick={handleCancelConfirm} />
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to do ?</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-danger"
//             onClick={() => {
//               if (applicationStatus === "Hired") {
//                 AcceptInterviewApplicationAsInst(
//                   instituteAppData.jbApplctnId,
//                   "Hired"
//                 );
//               } else if (applicationStatus === "Blocked") {
//                 AcceptInterviewApplicationAsInst(
//                   instituteAppData.jbApplctnId,
//                   "Blocked"
//                 );
//               } else if (applicationStatus === "Rejected") {
//                 AcceptInterviewApplicationAsInst(
//                   instituteAppData.jbApplctnId,
//                   "Rejected"
//                 );
//               }
//             }}
//           >
//             Confirm
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/*.................................... Assign test Modal end ................................*/}

//       {/*.................................... History Job Modal Start ................................*/}

//       <Modal show={showHistoryModal} onHide={handleCloseHistoryModal} centered>
//         <Modal.Header>
//           <Modal.Title> Job History</Modal.Title>
//           <CloseSharpIcon
//             className="pointer"
//             onClick={handleCloseHistoryModal}
//           />
//         </Modal.Header>
//         <Modal.Body className="settings">
//           {jobHistory && jobHistory.length > 0 ? (
//             jobHistory.map((data, index) => (
//               <div className="profile-resume-user-acvtivity mt-4" key={index}>
//                 <div className="d-flex justify-content-between mb-2 align-center">
//                   <div className="d-flex align-items-center">
//                     <div
//                       className={`profile-resume-applied-status me-2 ${
//                         data.hiringStatus === 1 || data.hiringStatus === 9
//                           ? "profile-resume-initial-icon"
//                           : data.hiringStatus === 5
//                           ? "profile-resume-cv-icon"
//                           : data.hiringStatus === 4 || data.hiringStatus === 6
//                           ? "profile-resume-success-icon"
//                           : ""
//                       }`}
//                     ></div>
//                     <div className="profile-resume-applied-jobs f-16 f-700">
//                       Hiring Status : {data.hiringStatusName}
//                     </div>
//                   </div>
//                   <div className="profile-resume-user-activity-time f-14 f-400">
//                     <span className="f-600">
//                       {moment
//                         .utc(data.time)
//                         .local()
//                         .format("DD MMM YYYY - hh : mm A")}{" "}
//                     </span>
//                   </div>
//                 </div>
//                 <div className="profile-resume-user-actvity-container mb-3">
//                   {data.remark === "" ? (
//                     ""
//                   ) : (
//                     <p className="f-14 f-400 mb-1">
//                       <span className="f-600">Remark :</span> {data.remark}
//                     </p>
//                   )}
//                   {data.scheduledInterviewInfo === null ? (
//                     ""
//                   ) : (
//                     <>
//                       <h6 className="f-600 mb-1">
//                         {" "}
//                         <u>Interview Details</u>{" "}
//                       </h6>
//                       {data.scheduledInterviewInfo.placeDetails === null ? (
//                         ""
//                       ) : (
//                         <p className="f-14 f-400 mb-1">
//                           <span className="f-600">Location : </span>
//                           {data.scheduledInterviewInfo.placeDetails}
//                         </p>
//                       )}
//                       {data.scheduledInterviewInfo.remark === null ? (
//                         ""
//                       ) : (
//                         <p className="f-14 f-400 mb-1">
//                           <span className="f-600">Remark : </span>
//                           {data.scheduledInterviewInfo.remark}
//                         </p>
//                       )}
//                       {data.scheduledInterviewInfo.placeType === null ? (
//                         ""
//                       ) : (
//                         <p className="f-14 f-400 mb-1">
//                           <span className="f-600">Place Type : </span>
//                           {data.scheduledInterviewInfo.placeType}
//                         </p>
//                       )}
//                       {data.scheduledInterviewInfo.scheduleTime === null ? (
//                         ""
//                       ) : (
//                         <div className="profile-resume-pdf-text f-14 f-500 d-conntents ">
//                           <CalendarMonthSharpIcon className="me-1" /> Date :{" "}
//                           {moment
//                             .utc(data.scheduledInterviewInfo.scheduleTime)
//                             .local()
//                             .format("DD MMM YYYY - hh : mm A")}
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p>No job history available.</p>
//           )}
//         </Modal.Body>
//       </Modal>
//       {/*.................................... history Job Modal End ................................*/}

//       {/*.................................... Info Job Modal Start ................................*/}

//       <Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
//         <Modal.Header>
//           <Modal.Title>Job Details</Modal.Title>
//           <CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
//         </Modal.Header>
//         <Modal.Body className="settings">
//           <div className=" mb-3">
//             {jobInfo.title === "" ? (
//               ""
//             ) : (
//               <p>
//                 <span className="f-600">Title : </span>
//                 {jobInfo.title}
//               </p>
//             )}

//             {jobInfo.compName === null ? (
//               ""
//             ) : (
//               <p>
//                 <span className="f-600"> Company : </span>
//                 {jobInfo.compName}
//               </p>
//             )}
//             {jobInfo.cityName === null ? (
//               ""
//             ) : (
//               <p>
//                 <span className="f-600">City : </span>
//                 {jobInfo.cityName}
//               </p>
//             )}
//             {jobInfo.designationName === null ? (
//               ""
//             ) : (
//               <p>
//                 <span className="f-600">Designation :</span>{" "}
//                 {jobInfo.designationName}
//               </p>
//             )}
//             {jobInfo.workLocationTypeName === null ? (
//               ""
//             ) : (
//               <p>
//                 <span className="f-600">Work Location :</span>{" "}
//                 {jobInfo.workLocationTypeName}
//               </p>
//             )}
//             {jobInfo.description === "" ? (
//               ""
//             ) : (
//               <p>
//                 <strong> Description : </strong>
//                 <div
//                   className=""
//                   dangerouslySetInnerHTML={{
//                     __html: linkifyContent(
//                       addTargetBlankToAnchors(jobInfo.description)
//                     ),
//                   }}
//                 ></div>
//               </p>
//             )}
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Link
//             to={`/job/${jobInfo?.jobId}`}
//             className="btn khojPrimaryBtn me-2"
//           >
//             View
//           </Link>
//         </Modal.Footer>
//       </Modal>
//       {/*.................................... Info Job Modal End ................................*/}
//       {/* ...............UnAuthorize modal............  */}
//       {unAuthorizeError ? (
//         <Modal show={unauthModal} centered>
//           <Modal.Header>
//             <Modal.Title>Unauthorize session expired</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="settings">
//             <div className=" mb-3">
//               <p>{unAuthorizeError}</p>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Link
//               className="pointer"
//               to="/Login"
//               onClick={() => {
//                 localStorage.removeItem("token"); // Remove authentication token
//                 sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
//                 localStorage.removeItem("Module");
//               }}
//             >
//               <button className="btn btn-danger ">Login</button>
//             </Link>
//             {/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}
//           </Modal.Footer>
//         </Modal>
//       ) : (
//         ""
//       )}
//     </>
//   );
// };

// export default RecentAplicants;
